// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AudioBanner.module.css */
.CommonScreen_container__fMSNF {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 150px 20px; /* Increased top padding */
    max-width: 960px;
    margin: 0 auto;
}

.CommonScreen_grid__huAEw {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    width: 100%;
}
.CommonScreen_pages__zdSuW{
    color: white;
}

.CommonScreen_item__SvcjR {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* More pronounced shadow */
    border: 1px solid #000000; /* Added border */
    cursor: pointer; /* Indicate clickability */
    transition: transform 0.2s ease-in-out; /* Smooth hover animation */
}

.CommonScreen_item__SvcjR:hover {
    transform: scale(1.05); /* Scale up on hover */
    border: 1px solid #ff0000;
    box-shadow: 0 6px 10px rgba(255, 252, 252, 0.105); /* More prominent shadow on hover */
}

.CommonScreen_image__zQOWG {
    width: 500px;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 8px;
}

.CommonScreen_overlay__uQ4hX {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2); /* Semi-transparent black overlay on hover */
    opacity: 0; /* Initially hidden */
    transition: opacity 0.2s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white; /* Text color within overlay */
}

.CommonScreen_item__SvcjR:hover .CommonScreen_overlay__uQ4hX {
    opacity: 1; /* Show overlay on hover */
}

.CommonScreen_pagination__dRHE3 {
    display: flex;
    justify-content: center;
    margin-top: 30px; /* Increased margin */
}

.CommonScreen_pageButton__ocnr0 {
    padding: 10px 20px;
    margin: 0 10px;
    border: none;
    border-radius: 6px; /* More rounded buttons */
    background-color: #e50000; /* Blue background */
    color: white;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out; /* Smooth transition */
}

.CommonScreen_pageButton__ocnr0:hover {
    background-color: #000000; /* Darker blue on hover */
}

.CommonScreen_pageButton__ocnr0:disabled {
    opacity: 0.6;
    cursor: default;
    background-color: #000000; /* Gray when disabled */
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .CommonScreen_grid__huAEw {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .CommonScreen_grid__huAEw {
        grid-template-columns: 1fr;
    }
    .CommonScreen_pageButton__ocnr0 {
        padding: 8px 16px; /* Slightly smaller buttons on small screens */
    }
}`, "",{"version":3,"sources":["webpack://./src/AudioSeries/Components/CSS/CommonScreen.module.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB,EAAE,0BAA0B;IAC/C,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,WAAW;AACf;AACA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC,EAAE,2BAA2B;IACrE,yBAAyB,EAAE,iBAAiB;IAC5C,eAAe,EAAE,0BAA0B;IAC3C,sCAAsC,EAAE,2BAA2B;AACvE;;AAEA;IACI,sBAAsB,EAAE,sBAAsB;IAC9C,yBAAyB;IACzB,iDAAiD,EAAE,mCAAmC;AAC1F;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,4CAA4C;IAClF,UAAU,EAAE,qBAAqB;IACjC,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY,EAAE,8BAA8B;AAChD;;AAEA;IACI,UAAU,EAAE,0BAA0B;AAC1C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB,EAAE,qBAAqB;AAC3C;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,kBAAkB,EAAE,yBAAyB;IAC7C,yBAAyB,EAAE,oBAAoB;IAC/C,YAAY;IACZ,eAAe;IACf,6CAA6C,EAAE,sBAAsB;AACzE;;AAEA;IACI,yBAAyB,EAAE,yBAAyB;AACxD;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB,EAAE,uBAAuB;AACtD;;AAEA,2BAA2B;AAC3B;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,iBAAiB,EAAE,8CAA8C;IACrE;AACJ","sourcesContent":["/* AudioBanner.module.css */\n.container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 150px 20px; /* Increased top padding */\n    max-width: 960px;\n    margin: 0 auto;\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 20px;\n    width: 100%;\n}\n.pages{\n    color: white;\n}\n\n.item {\n    position: relative;\n    overflow: hidden;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* More pronounced shadow */\n    border: 1px solid #000000; /* Added border */\n    cursor: pointer; /* Indicate clickability */\n    transition: transform 0.2s ease-in-out; /* Smooth hover animation */\n}\n\n.item:hover {\n    transform: scale(1.05); /* Scale up on hover */\n    border: 1px solid #ff0000;\n    box-shadow: 0 6px 10px rgba(255, 252, 252, 0.105); /* More prominent shadow on hover */\n}\n\n.image {\n    width: 500px;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n    border-radius: 8px;\n}\n\n.overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.2); /* Semi-transparent black overlay on hover */\n    opacity: 0; /* Initially hidden */\n    transition: opacity 0.2s ease-in-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white; /* Text color within overlay */\n}\n\n.item:hover .overlay {\n    opacity: 1; /* Show overlay on hover */\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    margin-top: 30px; /* Increased margin */\n}\n\n.pageButton {\n    padding: 10px 20px;\n    margin: 0 10px;\n    border: none;\n    border-radius: 6px; /* More rounded buttons */\n    background-color: #e50000; /* Blue background */\n    color: white;\n    cursor: pointer;\n    transition: background-color 0.2s ease-in-out; /* Smooth transition */\n}\n\n.pageButton:hover {\n    background-color: #000000; /* Darker blue on hover */\n}\n\n.pageButton:disabled {\n    opacity: 0.6;\n    cursor: default;\n    background-color: #000000; /* Gray when disabled */\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 480px) {\n    .grid {\n        grid-template-columns: 1fr;\n    }\n    .pageButton {\n        padding: 8px 16px; /* Slightly smaller buttons on small screens */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CommonScreen_container__fMSNF`,
	"grid": `CommonScreen_grid__huAEw`,
	"pages": `CommonScreen_pages__zdSuW`,
	"item": `CommonScreen_item__SvcjR`,
	"image": `CommonScreen_image__zQOWG`,
	"overlay": `CommonScreen_overlay__uQ4hX`,
	"pagination": `CommonScreen_pagination__dRHE3`,
	"pageButton": `CommonScreen_pageButton__ocnr0`
};
export default ___CSS_LOADER_EXPORT___;
